import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Formik, Form, FieldArray } from "formik";
import ButtonContained from "../button";
import { AddOrderSchema } from "../../validation/ValidationSchema";
import { api } from "../../api";
import { getProducts } from "../../helpers/listsApi";
import DynamicAddProductRow from "../addProductRow/DynamicAddProductRow";
import { toast } from "react-toastify";

const AddOrder = () => {
  const token = useSelector((state) => state.auth.token);
  const { userType: role } = useSelector((state) => state.auth.user);
  const navigate = useNavigate();

  const [products, setproducts] = useState([]);
  const [cartData, setCartData] = useState("");

  console.log(products);

  useEffect(() => {
    getProducts(null, token)
      .then((res) => {
        setproducts(res);
      })
      .catch((err) => console.log(err));
  }, [token]);

  useEffect(() => {
    api.orders.getCarts({}, token).then((result) => {
      if (result.success === true) {
        setCartData(result.data);
      }
      // else {
      //     toaster(result.message, 'error')
      // }
    });
  }, [token]);

  const handleCart = () => {
    if (cartData.length > 0) {
      navigate("/orders-details");
    }

    if (role === 3) {
      api.orders.getCarts({}, token).then((result) => {
        if (result.success === true) {
          setCartData(result.data);
        } else {
          toast.error(result.message);
        }
      });
    }
  };

  return (
    <Formik
      validationSchema={AddOrderSchema}
      initialValues={{
        productAccess: [
          {
            quantity: "",
            productName: "",
          },
        ],
      }}
      onSubmit={(Values, { resetForm, setSubmitting }) => {
        const productsArray = [];
        for (const dt of Values.productAccess) {
          if (dt.productName?.isEpay && Number(dt.quantity) > 1) {
            toast.error("Epay products can only be added with a quantity of 1.");
            setSubmitting(false);
            return;
          }
          productsArray.push({
            productId: dt.productName.value,
            quantity: dt.quantity,
          });
        }
        const isEpayProduct = Values.productAccess[0]?.productName?.isEpay;
        const alreadyInCart = cartData.length > 0 && cartData.some(
          (item) => item.productId === productsArray[0].productId
        );

        if (isEpayProduct && alreadyInCart) {
          toast.error("Epay products can only be added once with a quantity of 1.");
          setSubmitting(false);
          return;
        }

        if (
          cartData.length === 0 ||
          (cartData.length > 0 &&
            cartData[0].productId === productsArray[0].productId)
        ) {
          api.orders.addTOCart({ productsArray }, token).then((result) => {
            if (result.success === true) {
              toast.success(result.message);

              navigate(`/orders-details`);
            } else {
              resetForm();
              toast.error(result.message);
            }
          });
        } else {
          resetForm();
          toast.error("There can only be one item in your cart at a time.");
        }
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
        isSubmitting,
        setFieldValue,
      }) => {
        return (
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="box-row">
                  <div className="table-head">
                    <h1 className="sec-header">ADD ORDER</h1>
                  </div>
                  <div className="card card-table">
                    <div className="card-header card-header-title"></div>
                    <div className="card-body gatepass-saveoutput">
                      <div className="reports">
                        <Form onSubmit={handleSubmit}>
                          <div className="card-header card-header-title  pl-0">
                            Product Details
                          </div>

                          <div
                            style={{
                              position: "absolute",
                              top: "50px",
                              right: "15px",
                            }}
                          >
                            <span className="view-btn" onClick={handleCart}>
                              <i
                                className="bx bx-cart float-right bold dropdown-toggle p-2"
                                style={{
                                  position: "relative",
                                  marginRight: "30px",
                                }}
                              >
                                <span
                                  style={{
                                    position: "absolute",
                                    top: "-15px",
                                    left: "18px",
                                    background: "#5C2E91",
                                    padding: "5px",
                                    borderRadius: "50%",
                                    lineHeight: "8px",
                                    color: "#fff",
                                    width: "30px",
                                    height: "30px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "14px",
                                  }}
                                >
                                  {cartData.length}
                                </span>
                              </i>
                            </span>
                          </div>

                          <FieldArray
                            name="productAccess"
                            render={(helper) => {
                              return (
                                <div>
                                  {values.productAccess &&
                                    values.productAccess.length > 0 &&
                                    values.productAccess.map(
                                      (productAccess, index) => {
                                        return (
                                          <DynamicAddProductRow
                                            key={index}
                                            index={index}
                                            values={values}
                                            handleChange={handleChange}
                                            handleRemoveProduct={() =>
                                              helper.remove(index)
                                            }
                                            setFieldValue={setFieldValue}
                                            touched={touched}
                                            errors={errors}
                                            products={products}
                                            isSubmitting={isSubmitting}
                                          />
                                        );
                                      }
                                    )}
                                  {/* <button
                                    disabled={isSubmitting}
                                    aria-label="Close"
                                    type="button"
                                    onClick={() => {
                                      helper.push({
                                        productName: "",
                                        quantity: "",
                                      });
                                    }}
                                    className="btn mt-3 submit-btn"
                                    htmlFor="gridCheck"
                                    style={{
                                      position: 'relative',
                                      top: '55px',
                                      right: ' -138px'
                                    }}
                                  >
                                    Add Product
                                  </button> */}
                                </div>
                              );
                            }}
                          ></FieldArray>

                          <ButtonContained
                            buttonName="Add To Cart"
                            disabled={isSubmitting}
                            className="my-new-button"
                          />
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

export default AddOrder;
